import moment from "moment";
import PropTypes from "prop-types";
import "./HistoryItem.css";

const ACTION_CLASSES = {
  Deleted: "delete",
  Created: "creation",
};

const HistoryItem = ({ item }) => {
  if (!item) return null;

  const { action, identity, dateTime, type, value } = item;
  const actionClass = ACTION_CLASSES[action] ?? "creation";

  return (
    <div className="history-item-container">
      <div className="history-item-main">
        <div className="history-item-left">
          <span className={`status-dot ${actionClass}`} aria-hidden="true" />
          <span className={`status-label ${actionClass}`}>{action}</span>
          <span className="history-item-title">{identity}</span>
        </div>
        <div className="item-datetime d-flex gap-1">
          <div className="d-flex gap-2">
            <span>{moment.utc(dateTime).local().format("DD.MM.YYYY")}</span>
            <span>{moment.utc(dateTime).local().format("HH:mm")}</span>
          </div>
        </div>
      </div>
      {type && value && (
        <div className="item-type-value">
          {type}: {value}
        </div>
      )}
    </div>
  );
};

HistoryItem.propTypes = {
  item: PropTypes.shape({
    action: PropTypes.string.isRequired,
    identity: PropTypes.string.isRequired,
    dateTime: PropTypes.string.isRequired,
    type: PropTypes.string,
    value: PropTypes.string,
  }),
};

export default HistoryItem;
